import useCallApi from '../../../utilities/axios'
import * as umServinceURL from '../../../services/um/umServiceURL'
import { useEffect, useState } from 'react'

const useResearcherType = () => {
    const callApi = useCallApi()
    const [researcherType, setResearcherType] = useState([])

    const getResearcher = async () => {
        try {
            const { data } = await callApi.axiosGet({
                url: umServinceURL.getResearcherType,
            })
            setResearcherType(data.result)
        } catch (error) {
            console.log('error', error)
        }
    }

    useEffect(() => {
        getResearcher()
    }, [])

    return { researcherType }
}

export default useResearcherType
